import {gsap} from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
gsap.registerPlugin(ScrollTrigger)

const five3Slides = () => {
    const slide1 = document.querySelector('.slide-1');
    const slide2 = document.querySelector('.slide-2');
    const slide3 = document.querySelector('.slide-3');
    // Slide 1
    const slide11 = document.querySelector('.slide-1-1');
    const slide12 = document.querySelector('.slide-1-2');
    const slide13 = document.querySelector('.slide-1-3');
    const slide14 = document.querySelector('.slide-1-4');
    // Slide 2
    const slide21 = document.querySelector('.slide-2-1');
    const slide22 = document.querySelector('.slide-2-2');
    const slide23 = document.querySelector('.slide-2-3');
    const slide24 = document.querySelector('.slide-2-4');
    // Slide 3
    const slide31 = document.querySelector('.slide-3-1');
    const slide32 = document.querySelector('.slide-3-2');
    const slide33 = document.querySelector('.slide-3-3');
    const slide34 = document.querySelector('.slide-3-4');

    let mm = gsap.matchMedia();

    
        const timeline = gsap.timeline({
            paused: true
        })

        // Set slide 1
        timeline.set(slide11, {
            autoAlpha: 0,
            y: 200,
        })
        timeline.set(slide12, {
            autoAlpha: 0,
            y: 200,
        })
        timeline.set(slide13, {
            autoAlpha: 0,
            y: 200,
        })
        timeline.set(slide14, {
            autoAlpha: 0,
            y: 200,
        })
        // Set slide 2
        timeline.set(slide21, {
            autoAlpha: 0,
            y: 200,
        })
        timeline.set(slide22, {
            autoAlpha: 0,
            y: 200,
        })
        timeline.set(slide23, {
            autoAlpha: 0,
            y: 200,
        })
        timeline.set(slide24, {
            autoAlpha: 0,
            y: 200,
        })
        // Set Slide 3
        timeline.set(slide31, {
            autoAlpha: 0,
            y: 200,
        })
        timeline.set(slide32, {
            autoAlpha: 0,
            y: 200,
        })
        timeline.set(slide33, {
            autoAlpha: 0,
            y: 200,
        })
        timeline.set(slide34, {
            autoAlpha: 0,
            y: 200,
        })

        // Slide 1 in
        timeline.to(slide12, {
            autoAlpha: 1,
            y: 0,
            duration: .75,
            ease: 'power1.inOut',
        })
        timeline.to(slide11, {
            autoAlpha: 1,
            y: 0,
            duration: .75,
            ease: 'power1.inOut',
        }, ".25")
        timeline.to(slide13, {
            autoAlpha: 1,
            y: 0,
            duration: .75,
            ease: 'power1.inOut',
        }, "<")
        timeline.to(slide14, {
            autoAlpha: 1,
            y: 0,
            duration: .75,
            ease: 'power1.inOut',
        }, "<.125")
        timeline.addLabel("slide1")

        // Slide 1 out
        timeline.to(slide11, {
            autoAlpha: 0,
            y: -200,
            duration: .75,
            ease: 'power1.inOut',
            delay: 2
        })
        timeline.to(slide13, {
            autoAlpha: 0,
            y: -200,
            duration: .75,
            ease: 'power1.inOut',

        }, "<")
        timeline.to(slide14, {
            autoAlpha: 0,
            y: -200,
            duration: .75,
            ease: 'power1.inOut',

        }, "<.125")

        // Slide 2 in
        timeline.to(slide21, {
            autoAlpha: 1,
            y: 0,
            duration: .75,
            ease: 'power1.inOut',
        })
        timeline.to(slide23, {
            autoAlpha: 1,
            y: 0,
            duration: .75,
            ease: 'power1.inOut',
        }, "<")
        timeline.to(slide24, {
            autoAlpha: 1,
            y: 0,
            duration: .75,
            ease: 'power1.inOut',
        }, "<.125")
        timeline.addLabel("slide2")

        // Slide 2 out
        timeline.to(slide21, {
            autoAlpha: 0,
            y: -200,
            duration: .75,
            ease: 'power1.inOut',
            delay: 2
        })
        timeline.to(slide23, {
            autoAlpha: 0,
            y: -200,
            duration: .75,
            ease: 'power1.inOut',

        }, "<")
        timeline.to(slide24, {
            autoAlpha: 0,
            y: -200,
            duration: .75,
            ease: 'power1.inOut',

        }, "<.125")

        // Slide 3 in
        timeline.to(slide31, {
            autoAlpha: 1,
            y: 0,
            duration: .75,
            ease: 'power1.inOut',
        })
        timeline.to(slide33, {
            autoAlpha: 1,
            y: 0,
            duration: .75,
            ease: 'power1.inOut',
        }, "<")
        timeline.to(slide34, {
            autoAlpha: 1,
            y: 0,
            duration: .75,
            ease: 'power1.inOut',
        }, "<.125")
        timeline.addLabel("slide3")
        // Hold slide 3
        timeline.to(slide31, {
            autoAlpha: 1,
            y: 0,
            duration: 2,
        })

    mm.add("(min-width: 1150px)", () => {
        // ScrollTrigger.create({
        //     animation: timeline,
        //     trigger: ".c-555-section",
        //     start: "top 60%",
        //     // end: "+=1000",
        //     // scrub: 1,
        //     markers: true,
        //     // pin: true,
        // })

        timeline.seek(0)
        setTimeout(function() {
            timeline.play()
        }, 1500)
    })

    // Mobile just show
    mm.add("(max-width: 1149px)", () => {
        gsap.set(slide11, {autoAlpha: 1,})
        gsap.set(slide12, {autoAlpha: 1,})
        gsap.set(slide13, {autoAlpha: 1,})
        gsap.set(slide14, {autoAlpha: 1,})
        gsap.set(slide21, {autoAlpha: 1,})
        gsap.set(slide22, {autoAlpha: 1,})
        gsap.set(slide23, {autoAlpha: 1,})
        gsap.set(slide24, {autoAlpha: 1,})
        gsap.set(slide31, {autoAlpha: 1,})
        gsap.set(slide32, {autoAlpha: 1,})
        gsap.set(slide33, {autoAlpha: 1,})
        gsap.set(slide34, {autoAlpha: 1,})
    })
}

const five3cta = () => {
    
    const cta = document.querySelector('.c-five3-guide-cta')

    let mm = gsap.matchMedia()

    mm.add("(min-width: 1150px)", () => {
        let timeline = gsap.timeline({
            paused: true
        })

        timeline.set(cta, {
            autoAlpha: 0,
            y: 125,
        })
        timeline.to(cta, {
            autoAlpha: 1,
            y: 0,
            duration: .6,
            ease: 'power2.inOut',
        })

        ScrollTrigger.create({
            animation: timeline,
            trigger: cta,
            // markers: true,
        })
    })
}

const five3Blocks = () => {

    const blocks = gsap.utils.toArray('.c-555-text' )
    const chevronLines = gsap.utils.toArray('.c-555-chevron-line' )
    const chevron = document.querySelector('.c-555-chevron')

    const timeline = gsap.timeline({
        paused: true
    })


    timeline.set(blocks, {
        autoAlpha: 0,
        x: -300,
    })
    timeline.set(chevronLines, {
        autoAlpha: 0,
        x: -400,
    })
    timeline.set(chevron, {
        autoAlpha: 0,
        y: -50,
    })

    timeline.to(blocks, {
        autoAlpha: 1,
        x: 0,
        duration: .5,
        ease: 'power3.out',
        stagger: {
            each: .375,
        }
    })
    timeline.to(chevronLines, {
        autoAlpha: 1,
        x: 0,
        duration: 1.2,
        ease: 'power2.inOut',
        stagger: {
            each: -.04,
        }
    }, "<")
    timeline.to(chevron, {
        autoAlpha: 1,
        y: -10,
        duration: .5,
        ease: 'power1.out',
    }, "<1.5")
    timeline.to(chevron, {
        y: -20,
        duration: .8,
        ease: 'sine.inOut',
        repeat: -1,
        yoyo: true
    })

    let mm = gsap.matchMedia();

    mm.add("(min-width: 576px)", () => {
        timeline.seek(0);
        timeline.play();
    })

    // Mobile just show
    mm.add("(max-width: 575px)", () => {
        gsap.set(chevronLines, {autoAlpha: 1,})
        gsap.set(blocks, {autoAlpha: 1,})
        gsap.set(chevron, {autoAlpha: 1,})
    })

}

const init = () => {
    five3Blocks()
    five3Slides()
    five3cta()
}

window.addEventListener('DOMContentLoaded', () => {
    init()
})